// extracted by mini-css-extract-plugin
module.exports = {"container":"bk_x","cropper":"bk_dd","resizer":"bk_df","hover":"bk_cd"};